import {combineReducers} from 'redux';
import * as authRedux from './authRedux/reducer';
import * as commonRedux from './commonRedux/reducer';

export default combineReducers({
  auth: authRedux.reducer,
  common: commonRedux.reducer,
});
